import React from 'react';
import {Button, Checkbox, Descriptions, Form, FormInstance, Space, List} from 'antd';
import {observer} from "mobx-react";
import {CardStyled} from "../../../components/styled/card.styled";
import {useFetcher, useLoaderData, useNavigate} from "react-router-dom";
import {Translate} from "../../../components/util/translation.util";
import {ButtonBar} from "../../../builder";

const layout = {

};

export const Accesses: React.FC = observer(() => {
    const fetcher = useFetcher<any>();
    const data: any = useLoaderData();
    const formRef = React.createRef<FormInstance>();
    const navigate = useNavigate();

    const onSubmit = async (values: any) => {
        await fetcher.submit({ data: JSON.stringify(values) }, { method: "post" });
        navigate(`/role`);
    }

    return (
        <Space direction="vertical" size="small" style={{ display: 'flex' }}>
            <CardStyled title={`Accesses`}>
                <Form {...layout} layout="vertical"  style={{ padding: '16px' }} ref={formRef} name="control-ref" onFinish={onSubmit} initialValues={data}>
                    <Space direction={`vertical`} style={{ display: 'flex' }}>
                        <Form.List name="accesses">
                            {(accesses) => (
                                <Descriptions bordered>
                                    {accesses.map((access) => (
                                        <Descriptions.Item key={access.key} span={3} label={<Translate message={data.accesses[access.name].name}/>}>
                                            <Form.List name={[access.name, 'actions']}>
                                                {(actions) => (
                                                    <List>
                                                        {actions.map((action) => (
                                                            <List.Item key={ action.key }>
                                                                <Form.Item {...action} valuePropName={`checked`} name={[action.name, 'selected']}>
                                                                    <Checkbox>
                                                                        <Translate message={data.accesses[access.name].actions[action.name].name} />
                                                                    </Checkbox>
                                                                </Form.Item>
                                                                { data.accesses[access.name].actions[action.name].limitValues.length > 0 &&
                                                                    <div style={{ marginLeft: '24px' }}>
                                                                        <Translate message={'Aspect Values'} />
                                                                        <div style={{ marginLeft: '24px' }}>
                                                                            <Form.List name={[action.name, 'limitValues']}>
                                                                                {(limitValues) => (
                                                                                    <>
                                                                                        {limitValues.map((value) => (
                                                                                            <div key={ value.key }>
                                                                                                <Translate message={data.accesses[access.name].actions[action.name].limitValues[value.name].name} />
                                                                                                <div style={{ marginLeft: '24px' }}>
                                                                                                    <Form.List name={[value.name, 'items']}>
                                                                                                        {(items) => (
                                                                                                            <>
                                                                                                                { items.map(item => (
                                                                                                                    <Form.Item {...item} valuePropName={`checked`} name={[item.name, 'selected']}>
                                                                                                                        <Checkbox>
                                                                                                                            <Translate message={data.accesses[access.name].actions[action.name].limitValues[value.name].items[item.name].name} />
                                                                                                                        </Checkbox>
                                                                                                                    </Form.Item>
                                                                                                                )) }
                                                                                                            </>
                                                                                                        )}
                                                                                                    </Form.List>
                                                                                                </div>
                                                                                            </div>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            </Form.List>
                                                                        </div>
                                                                    </div>
                                                                }

                                                                { data.accesses[access.name].actions[action.name].limitFunctions.length > 0 &&
                                                                    <div style={{ marginLeft: '24px' }}>
                                                                        <Translate message={'Aspect Functions'} />
                                                                        <div style={{ marginLeft: '24px' }}>
                                                                            <Form.List name={[action.name, 'limitFunctions']}>
                                                                                {(limitFunctions) => (
                                                                                    <>
                                                                                        {limitFunctions.map((limitFunction) => (
                                                                                            <Form.Item {...limitFunction} valuePropName={`checked`} name={[limitFunction.name, 'selected']}>
                                                                                                <Checkbox>
                                                                                                    <Translate message={data.accesses[access.name].actions[action.name].limitFunctions[limitFunction.name].name} />
                                                                                                </Checkbox>
                                                                                            </Form.Item>
                                                                                        ))}
                                                                                    </>
                                                                                )}
                                                                            </Form.List>
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </List.Item>
                                                        ))}
                                                    </List>
                                                )}
                                            </Form.List>
                                        </Descriptions.Item>
                                    ))}
                                </Descriptions>
                            )}
                        </Form.List>
                    </Space>
                </Form>
            </CardStyled>

            <ButtonBar>
                <Button type="primary" htmlType={`submit`} onClick={() => {
                    formRef.current?.submit();
                }}><Translate message={`global.button.save`} /></Button>

                <Button type="primary" className={`ant-btn-secondary`} onClick={() => {
                    navigate(`/role`);
                }}><Translate message={`global.button.back_to_list`} /></Button>
            </ButtonBar>
        </Space>
    )
})